import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HcpSwitchoverApi } from '../../../apis/HcpSwitchoverApi/HcpSwitchoverApi.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';

export const useSetHcpSwitchoverExclusion = () => {
    const queryClient = useQueryClient();

    return useMutation<void, AppMedError, { healthcareProfessionalId: number; excluded: boolean }>({
        mutationFn: ({ healthcareProfessionalId, excluded }) => HcpSwitchoverApi.setExcluded(healthcareProfessionalId, excluded),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.hcpSwitchoverLegacyHcps] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.hcpSwitchoverReadiness] });
        },
    });
};
